<div
  #contentBlock
  class="support-page">
  <div class="page-head">
    <div class="page-head__left">
      <button
        *appHasAccess="['SUPPORT_ADD']"
        (click)="openModalAdd()"
        class="btn btn-accent-filter icon">
        <img
          src="assets/img/add.svg"
          alt="icon"
          class="icon-button" />
        {{ "SUPPORT_PAGE.NEW_CONTACTING" | translate }}
      </button>
    </div>
    <div class="page-head__right">
      <app-filter-button
        [isOpenFilter]="isOpenFilter"
        [isEnableUpload]="false"
        (toggleFilterEvent)="toggleFilter($event)">
      </app-filter-button>
    </div>
  </div>

  <div class="payment-page__filer">
    <app-filter-block
      [additional]="filterAdditional"
      [(isOpenFilter)]="isOpenFilter">
      <app-support-page-filter
        [filterSupportTypes]="filterSupportTypes"
        [filterStatuses]="filterStatuses">
      </app-support-page-filter>
    </app-filter-block>
  </div>

  <div
    #supportBlock
    class="support-page__block">
    <div
      (scroll)="onScroll($event)"
      class="support-page__block-left">
      <div #tableBody>
        <app-contacting-support-item
          *ngFor="let item of supportList"
          [item]="item"
          [selectedId]="selectedSupportItem?.support_id"
          (click)="openDetailSupport(item.support_id)">
        </app-contacting-support-item>
      </div>
    </div>
    <div
      *ngIf="selectedSupportItem"
      class="support-page__block-right">
      <app-contacting-support-detail
        (fileNotLoadedEvent)="openNotDownloadNotification()"
        (editedContactingEvent)="openEditedNotification()"
        (closeWithoutEdit)="openDetailSupport($event)"
        [supportTypeList]="supportTypeList"
        [supportStatusList]="supportStatusList">
      </app-contacting-support-detail>
    </div>
  </div>
</div>

<app-modal
  [isOpenModal]="isOpenAddContactingDialog"
  [isFull]="true">
  <app-add-contacting-dialog
    *ngIf="isOpenAddContactingDialog"
    (fileNotLoadedEvent)="openNotDownloadNotification()"
    (createdConnectingEvent)="openCreatedNotification()"
    [supportTypeList]="supportTypeList">
  </app-add-contacting-dialog>
</app-modal>

<app-modal
  [isFull]="true"
  [isOpenModal]="isOpenDetailContactingDialog">
  <app-contacting-support-detail
    (editedContactingEvent)="openEditedNotification()"
    (fileNotLoadedEvent)="openNotDownloadNotification()"
    (closeWithoutEdit)="openDetailSupport($event)"
    [supportTypeList]="supportTypeList"
    [supportStatusList]="supportStatusList">
  </app-contacting-support-detail>
</app-modal>
